import { render } from "./HomeLanding.vue?vue&type=template&id=689c1494"
import script from "./HomeLanding.vue?vue&type=script&lang=js"
export * from "./HomeLanding.vue?vue&type=script&lang=js"

import "./HomeLanding.vue?vue&type=style&index=0&id=689c1494&lang=css"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__